



















































































































import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import { EventInfo, Boat } from '@/api/product';
import { Getter, Mutation } from 'vuex-class';
import TicketCategory, { CartItem } from '@/api/tickets';
import moment from 'moment-timezone';
import { Item } from '@/api/paypal';
import { itemToGtag } from '@/api/gtag';
import MakeDeposit from '@/components/stripe/MakeDeposit.vue';

@Component({
  components: {MakeDeposit},
  filters: {
    money: (value: string | number) => {
      const val = Number(value);
      return '$' + val.toFixed(2);
    },
    capitalize: (value: string) => {
      if (!value) { return ''; }
      return value[0].toUpperCase() + value.slice(1);
    },
  },
})
export default class EventView extends Vue {
  @Prop(Boolean) public readonly value!: boolean;
  @Prop(Object) public readonly event!: EventInfo | null;
  @Prop() public readonly activator!: EventTarget | null;
  @Getter('tickets/categoryByName') public getPrices!: (name: string) => null | TicketCategory;
  @Mutation('cart/addCartItem') public addToCart!: (item: CartItem) => void;
  @Getter('cart/total') public readonly total!: number;
  @Getter('cart/items') public readonly items!: CartItem[];
  @Getter('product/boatByID') public getBoat!: (id: number) => Boat;
  @Inject() public readonly flags!: object;

  public qty: {[name: string]: string} = {
    adult: '0',
    child: '0',
    senior: '0',
  };

  public get prices(): Array<{name: string, price: number}> {
    const ret: Array<{name: string, price: number}> = [];
    if (this.event === null) {
      return ret;
    }
    const prices = this.getPrices(this.event.price);
    if (prices === null) {
      return ret;
    }

    for (const cat of Object.keys(prices.categories)) {
      const p = Number(prices.categories[cat]);
      if (p > 0) {
        ret.push({name: cat, price: p});
        if (!(cat in this.qty)) {
          this.qty[cat] = '0';
        }
      }
    }
    return ret;
  }

  public get incart(): {[name: string]: number} {
    if (this.event === null) { return {}; }
    const start = moment(this.event.start, 'YYYY-MM-DD H:mm').tz('America/New_York', true);

    const ret: {[name: string]: number} = {};
    for (const p of this.prices) {
      const sku = this.event.id.toString() + p.name.toUpperCase() + String(start.unix());
      const item = this.items.find((c) => c.item.sku === sku);
      ret[p.name] = item ? Number(item.item.quantity) : 0;
    }
    return ret;
  }

  public get allincart(): number {
    return Object.values(this.incart).reduce((a, b) => a + b);
  }

  public needBigger(): boolean {
    return this.$isMobile() && screen.orientation.type === 'portrait-primary';
  }

  public createItem(type: string, price: number): Item {
    const start = moment(this.event!.start, 'YYYY-MM-DD H:mm').tz('America/New_York', true);
    const desc = this.event!.name + ', ' + start.format('M/D/Y, h:mm A');
    return {
      sku: this.event!.id.toString() + type.toUpperCase() + String(start.unix()),
      name: type[0].toUpperCase() + type.slice(1) + ' Ticket, ' + this.getBoat(this.event!.boatId).name + ', ' + desc,
      description: '',
      quantity: '1',
      unit_amount: { value: price.toFixed(2), currency_code: 'USD' },
    };
  }

  public remove(p: {name: string, price: number}) {
    if (this.event === null) { return; }
    const item = this.createItem(p.name, p.price);
    item.quantity = '-1';
    this.$gtag.event('remove_from_cart', {items: [ itemToGtag(item) ]});
    this.addToCart({event: this.event, item});
  }

  public add(p: {name: string, price: number}) {
    if (this.event === null) { return; }
    const item = this.createItem(p.name, p.price);
    item.quantity = this.qty[p.name] || '0';

    this.$gtag.event('add_to_cart', {items: [itemToGtag(item)]});

    this.addToCart({event: this.event, item});
    this.qty[p.name] = '0';
  }

  public close() {
    this.$emit('input', false);
  }
}
